import React, { Component } from "react";
import ResolveComponent from '../components/ResolveComponent';
import Landing from '../../landing/containers/LandingContainer';
import { sendService, sendFile, openFile, sendServiceAsync } from "../../Services/service";
import { initMap } from '../components/mapInform'

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../Actions/Dashboard';
import * as ModalActs from '../../Actions/Modal';

import "../style.css";

class Requests extends Component {
  state = {
    data: {},
    images: [],
    attaceds: [],
    requestId: 0,
    form: {},
    sendigFile: false,
    progVisit: false
  }

  updateRequest = async () => {
    this.setState({ sendigFile: true })
    const u = await sendService('/api/v1/citizen/updateRequest', 'post', {
      request: {
        ...this.state.data,
        refRequestStateId: this.state.data.decision ? 4 : this.state.data.refRequestStateId,
      },
      attaceds: this.state.attaceds
    })
    this.setState({ sendigFile: false })
    return u
  }

  onUploadAttached = (files) => {

    this.setState({ sendigFile: true })
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('file', files[i]);
    }

    sendFile(
      '/api/v1/citizen/uploadFile',
      formData,
      {
        end: (r) => {
          const attc = [
            ...this.state.attaceds,
            {
              citizenFileId: r.id,
              url: r.url,
              refRequestFileId: 2,
              name: files[0].name,
              requestId: this.state.data.id
            }
          ]
          this.setState({ attaceds: attc, sendigFile: false })
        }
      }
    )
  }

  onChangeRoute = (route) => {
    this.props.actions.activePage(route);
    this.props.history.push(route);
  }

  handlerChange = (key, value) => {
    this.setState({
      data: {
        ...this.state.data,
        [key]: value
      }
    })
  }

  handlerChangeState = (key, value) => {
    this.setState({ [key]: value })
  }

  componentDidMount() {
    const currentUrl = window.location.href;
    const urlSplit = currentUrl.split('/')
    const requestId = urlSplit[urlSplit.length - 1]
    this.setState({ requestId })
    this.getRequestData(requestId)
  }

  save = async () => {
    if (this.state.progVisit) {
      sendService(`/api/v1/citizen/setVisit`, "POST", {
        request: {
          ...this.state.data,
          refRequestStateId: 2,
        },
        attaceds: this.state.attaceds
      }).then(value => {
        if (value.status === 200) {
          this.onChangeRoute('/ep/requests')
          window.location.href = '/ep/requests'
        }
      })
    } else {
      const value = await this.updateRequest()
      if (value.status === 200) {
        this.onChangeRoute('/ep/requests')
        window.location.href = '/ep/requests'
      }
      // sendService(`/api/v1/citizen/downloadDesicion`, "POST", {
      //   request: {
      //     ...this.state.data,
      //     refRequestStateId: 4,
      //   },
      //   attaceds: this.state.attaceds
      // }).then(value => {
      //   if (value.status === 200) {
      //     this.onChangeRoute('/ep/requests')
      //     window.location.href = '/ep/requests'
      //   }
      // })
    }
  }

  downloadDecision = () => {
    if (this.state.data.decision && this.state.data.decision !== '') {
      sendServiceAsync(`/api/v1/citizen/downloadDesicion`, "POST", {
        request: {
          ...this.state.data,
          refRequestStateId: 4,
        }
      }).then(value => {
        if (value.status === 200) {
          value.blob().then(file => {
            openFile(file, 'Decision_' + this.state.requestId + '.docx')
          })
        }
      })
    } else {
      alert('Favor ingresar "Descripción de la decisión"')
    }
  }

  getRequestData = (id) => {
    sendService(`/api/v1/citizen/request/${id}`, "GET").then(value => {
      if (value.status === 200) {
        if (value.response.length) {
          this.setState({
            data: value.response[0].request,
            images: value.response.map(i => {
              return {
                ...i.citizenFile,
                refRequestFileId: i.refRequestFileId
              }
            })
          })
          if (value.response[0].request.lat !== null)
            initMap({
              id: 'map-resolve',
              svid: 'street-view-resolve',
              zoom: 17,
              center: {
                lat: value.response[0].request.lat,
                lng: value.response[0].request.lng
              }
            })
        }
      }
    })
  }

  render() {
    return (
      <Landing history={this.props.history} hasFooter={false}>
        {
          !!this.state.images.length &&
          <ResolveComponent
            state={this.state}
            onChangeRoute={this.onChangeRoute}
            onChangeForm={this.handlerChange}
            onChangeState={this.handlerChangeState}
            onSave={this.save}
            onAttach={this.onUploadAttached}
            onDownloadDecision={this.downloadDecision}
          />
        }
      </Landing>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    modalActions: bindActionCreators(ModalActs, dispatch),
  }
}

export default connect(null, mapDispatchToProps)(Requests);